import {useEffect, useRef} from 'react';
import shallowEquals from 'shallowequal';

export type CustomEquals<T> = (previous: T | undefined, current: T) => boolean;

function useOriginalCopy<T>(value: T, equals: CustomEquals<T> = shallowEquals): T {
    const cache = useRef<T>(value);
    const equalsRef = useRef(equals);

    useEffect(
        () => {
            equalsRef.current = equals;
        },
        [equals]
    );

    useEffect(
        () => {
            if (!equalsRef.current(cache.current, value)) {
                cache.current = value;
            }
        },
        [value]
    );

    return equals(cache.current, value) ? cache.current : value;
}

export default useOriginalCopy;